import React from "react";
import { PlanPaymentFormView } from "./view";
import { styles } from "./styles";

export class PlanPaymentForm extends React.Component {
  render() {
    return <PlanPaymentFormView {...this.props} styles={styles} />;
  }
}
